const CLIENTES_HARDCODED_YPF = {
  totalClientes: 8567,
  pageSize: 20,
  totalPages: 429,
  currentPage: 1,
  clientes: [
    {
      idCliente: 3,
      codigo: "65909 ",
      razonSocial: "AORL SRL (FR)",
      tipoDomicilio: null,
      calle: "JULIO A ROCA 241",
      puerta: "0",
      piso: "",
      depto: "",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      localidad: {
        idLocalidad: 1868,
        nombreLocalidad: "LONQUIMAY                               ",
        codigoPostal: 6352,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 11,
          nombreProvincia: "LA PAMPA                      ",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 0,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO         ",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CUENTA CORRIENTE",
        condicionVentaContado: false,
        idCondicionVenta: 0,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "33-71426590-9",
      numeroListaPrecios: 0,
      identificador: "",
      enviaResumenPorMail: true,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: true,
      emiteRemito: false,
      exigeDatosVehiculo: true,
      exigeChofer: true,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 4,
      codigo: "65909 ",
      razonSocial: "RPE SRL (R)",
      tipoDomicilio: null,
      calle: "ALEM A 3041",
      puerta: "0",
      piso: "",
      depto: "",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      localidad: {
        idLocalidad: 1868,
        nombreLocalidad: "LONQUIMAY                               ",
        codigoPostal: 6352,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 11,
          nombreProvincia: "LA PAMPA                      ",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 0,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO         ",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CUENTA CORRIENTE",
        condicionVentaContado: false,
        idCondicionVenta: 0,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-41526090-2",
      numeroListaPrecios: 0,
      identificador: "",
      enviaResumenPorMail: true,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: true,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 30,
      codigo: "A0030",
      razonSocial: "ACME S.A.",
      tipoDomicilio: null,
      calle: "MITRE",
      puerta: "100",
      codigoPostal: 1000,
      piso: "2",
      depto: "A",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      idCategoriaIVA: 1,
      localidad: {
        idLocalidad: 2101,
        nombreLocalidad: "CABA",
        codigoPostal: 1000,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 1,
          nombreProvincia: "BUENOS AIRES",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "contacto@acme.com.ar",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 1,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 1,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-12345678-1",
      numeroListaPrecios: 1,
      identificador: "",
      enviaResumenPorMail: false,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 31,
      codigo: "A0031",
      razonSocial: "ACTIVA ENERGÍA S.R.L.",
      tipoDomicilio: null,
      calle: "RIVADAVIA",
      puerta: "156",
      codigoPostal: 2000,
      piso: "3",
      depto: "B",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      idCategoriaIVA: 1,
      localidad: {
        idLocalidad: 2102,
        nombreLocalidad: "ROSARIO",
        codigoPostal: 2000,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 2,
          nombreProvincia: "SANTA FE",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "info@activaenergia.com",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 1,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 1,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-23456789-2",
      numeroListaPrecios: 1,
      identificador: "",
      enviaResumenPorMail: false,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 32,
      codigo: "A0032",
      razonSocial: "AGRO LÍDER S.A.",
      tipoDomicilio: null,
      calle: "SARMIENTO",
      puerta: "250",
      codigoPostal: 7600,
      piso: "1",
      depto: "C",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      idCategoriaIVA: 1,
      localidad: {
        idLocalidad: 2103,
        nombreLocalidad: "MAR DEL PLATA",
        codigoPostal: 7600,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 1,
          nombreProvincia: "BUENOS AIRES",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "ventas@agrolider.com.ar",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 1,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 1,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-34567890-3",
      numeroListaPrecios: 1,
      identificador: "",
      enviaResumenPorMail: false,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 33,
      codigo: "A0033",
      razonSocial: "ALFA SISTEMAS S.A.",
      tipoDomicilio: null,
      calle: "BELGRANO",
      puerta: "15",
      codigoPostal: 1700,
      piso: "PB",
      depto: null,
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      idCategoriaIVA: 1,
      localidad: {
        idLocalidad: 2104,
        nombreLocalidad: "MORÓN",
        codigoPostal: 1700,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 1,
          nombreProvincia: "BUENOS AIRES",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "contacto@alfasistemas.com",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 1,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 1,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-45678901-4",
      numeroListaPrecios: 1,
      identificador: "",
      enviaResumenPorMail: false,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 34,
      codigo: "A0034",
      razonSocial: "ALIMENTOS DEL SUR S.R.L.",
      tipoDomicilio: null,
      calle: "ALSINA",
      puerta: "999",
      codigoPostal: 8000,
      piso: "1",
      depto: "A",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      idCategoriaIVA: 1,
      localidad: {
        idLocalidad: 2107,
        nombreLocalidad: "BAHIA BLANCA",
        codigoPostal: 8000,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 1,
          nombreProvincia: "BUENOS AIRES",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "ventas@alimentosdelsur.com",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 1,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 1,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-56789012-5",
      numeroListaPrecios: 1,
      identificador: "",
      enviaResumenPorMail: false,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 35,
      codigo: "A0035",
      razonSocial: "AMBAR INGENIERÍA S.A.",
      tipoDomicilio: null,
      calle: "JUJUY",
      puerta: "200",
      codigoPostal: 1400,
      piso: "5",
      depto: "B",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      idCategoriaIVA: 1,
      localidad: {
        idLocalidad: 2105,
        nombreLocalidad: "VILLA MARÍA",
        codigoPostal: 1400,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 3,
          nombreProvincia: "CORDOBA",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "info@ambaringenieria.com",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 1,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 1,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-67890123-6",
      numeroListaPrecios: 1,
      identificador: "",
      enviaResumenPorMail: false,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 36,
      codigo: "A0036",
      razonSocial: "ANDES SOFTWARE S.A.",
      tipoDomicilio: null,
      calle: "LAVALLE",
      puerta: "50",
      codigoPostal: 5500,
      piso: "4",
      depto: "C",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      idCategoriaIVA: 1,
      localidad: {
        idLocalidad: 2106,
        nombreLocalidad: "MENDOZA",
        codigoPostal: 5500,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 4,
          nombreProvincia: "MENDOZA",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "contacto@andessoftware.com",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 1,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 1,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-78901234-7",
      numeroListaPrecios: 1,
      identificador: "",
      enviaResumenPorMail: false,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 37,
      codigo: "A0037",
      razonSocial: "ANTÁRTIDA LOGÍSTICA S.R.L.",
      tipoDomicilio: null,
      calle: "SAN MARTÍN",
      puerta: "1234",
      codigoPostal: 1600,
      piso: "6",
      depto: "D",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      idCategoriaIVA: 1,
      localidad: {
        idLocalidad: 2108,
        nombreLocalidad: "VICENTE LÓPEZ",
        codigoPostal: 1600,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 1,
          nombreProvincia: "BUENOS AIRES",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "info@antartidalogistica.com",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 1,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 1,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-89012345-8",
      numeroListaPrecios: 1,
      identificador: "",
      enviaResumenPorMail: false,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 38,
      codigo: "A0038",
      razonSocial: "APEX CONSULTORA S.A.",
      tipoDomicilio: null,
      calle: "PUEYRREDÓN",
      puerta: "890",
      codigoPostal: 5000,
      piso: "7",
      depto: "E",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      idCategoriaIVA: 1,
      localidad: {
        idLocalidad: 2109,
        nombreLocalidad: "CÓRDOBA",
        codigoPostal: 5000,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 3,
          nombreProvincia: "CORDOBA",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "info@apexconsultora.com",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 1,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 1,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-90123456-9",
      numeroListaPrecios: 1,
      identificador: "",
      enviaResumenPorMail: false,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 39,
      codigo: "A0039",
      razonSocial: "ARPEGIO MUSICAL S.R.L.",
      tipoDomicilio: null,
      calle: "COLÓN",
      puerta: "777",
      codigoPostal: 8000,
      piso: "1",
      depto: "B",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      idCategoriaIVA: 1,
      localidad: {
        idLocalidad: 2107,
        nombreLocalidad: "BAHIA BLANCA",
        codigoPostal: 8000,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 1,
          nombreProvincia: "BUENOS AIRES",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "info@arpegiomusical.com",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 1,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 1,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-91234567-0",
      numeroListaPrecios: 1,
      identificador: "",
      enviaResumenPorMail: false,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 1,
      codigo: "A0001 ",
      razonSocial: "AONIKEN SERVICIOS IT S.A.",
      tipoDomicilio: null,
      calle: "SAAVEDRA",
      puerta: "39",
      codigoPostal: 8000,
      piso: "7",
      depto: "B",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      idCategoriaIVA: 1,
      localidad: {
        idLocalidad: 2107,
        nombreLocalidad: "BAHIA BLANCA                            ",
        codigoPostal: 8000,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 1,
          nombreProvincia: "BUENOS AIRES                  ",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "correo@grupoaoniken.com.ar",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 1,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO         ",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 1,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-70861716-0",
      numeroListaPrecios: 1,
      identificador: "",
      enviaResumenPorMail: false,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 5055,
      codigo: "71003 ",
      razonSocial: "30 ESTRELLAS",
      tipoDomicilio: null,
      calle: "ESPAÑA 42",
      puerta: "0",
      piso: "",
      depto: "",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      localidad: {
        idLocalidad: 2152,
        nombreLocalidad: "GENERAL ACHA                            ",
        codigoPostal: 8200,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 11,
          nombreProvincia: "LA PAMPA                      ",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 0,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO         ",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 0,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-71767100-3",
      numeroListaPrecios: 0,
      identificador: "",
      enviaResumenPorMail: true,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 43,
      codigo: "1     ",
      razonSocial: "CALZADOS Y ACCESOR",
      tipoDomicilio: null,
      calle: "ALCORTA 47",
      puerta: "0",
      piso: "",
      depto: "",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      localidad: {
        idLocalidad: 1841,
        nombreLocalidad: "SANTA ROSA                              ",
        codigoPostal: 6300,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 11,
          nombreProvincia: "LA PAMPA                      ",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 0,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO         ",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 0,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-69788727-6",
      numeroListaPrecios: 0,
      identificador: "",
      enviaResumenPorMail: true,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 4540,
      codigo: "43831 ",
      razonSocial: "44F S.A.",
      tipoDomicilio: null,
      calle: "HIPOLITO IRIGOYEN 1383 PISO:PA",
      puerta: "0",
      piso: "",
      depto: "",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      localidad: {
        idLocalidad: 1849,
        nombreLocalidad: "COLONIA BARON                           ",
        codigoPostal: 6315,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 11,
          nombreProvincia: "LA PAMPA                      ",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 0,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO         ",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 0,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-71464383-1",
      numeroListaPrecios: 0,
      identificador: "",
      enviaResumenPorMail: true,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: true,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 2,
      codigo: "2     ",
      razonSocial: "A L A SRL",
      tipoDomicilio: null,
      calle: "GRAL.PAZ 705",
      puerta: "0",
      piso: "",
      depto: "",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      localidad: {
        idLocalidad: 579,
        nombreLocalidad: "ALVAREZ                                 ",
        codigoPostal: 2107,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 21,
          nombreProvincia: "SANTA FE                      ",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "Test@gmail.com",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 0,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO         ",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 0,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "33-61057188-9",
      numeroListaPrecios: 0,
      identificador: "",
      enviaResumenPorMail: true,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 5994,
      codigo: "99978 ",
      razonSocial: "A LEANDRO RAFAEL MARTIN",
      tipoDomicilio: null,
      calle: "THORNE 1121",
      puerta: "0",
      piso: "",
      depto: "",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      localidad: {
        idLocalidad: 490,
        nombreLocalidad: "VILLA MADERO (BS. AS.)                  ",
        codigoPostal: 1768,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 1,
          nombreProvincia: "BUENOS AIRES                  ",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 0,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO         ",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 0,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "20-08461446-8",
      numeroListaPrecios: 0,
      identificador: "",
      enviaResumenPorMail: true,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 2728,
      codigo: "9803  ",
      razonSocial: "MARTIÑER SRL",
      tipoDomicilio: null,
      calle: "AVELLANEDA 144",
      puerta: "0",
      piso: "",
      depto: "",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      localidad: {
        idLocalidad: 1841,
        nombreLocalidad: "SANTA ROSA                              ",
        codigoPostal: 6300,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 11,
          nombreProvincia: "LA PAMPA                      ",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 0,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO         ",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 0,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "33-69356751-9",
      numeroListaPrecios: 0,
      identificador: "",
      enviaResumenPorMail: true,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 7513,
      codigo: "13044 ",
      razonSocial: "PRUDENIA SRL",
      tipoDomicilio: null,
      calle: "YRIGOYEN 2441 MARTINEZ BUENOS ",
      puerta: "0",
      piso: "",
      depto: "",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      localidad: {
        idLocalidad: 1841,
        nombreLocalidad: "SANTA ROSA                              ",
        codigoPostal: 6300,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 11,
          nombreProvincia: "LA PAMPA                      ",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 0,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO         ",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 0,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-51674005-8",
      numeroListaPrecios: 0,
      identificador: "",
      enviaResumenPorMail: true,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
    {
      idCliente: 15,
      codigo: "5     ",
      razonSocial: "PIL SRL",
      tipoDomicilio: null,
      calle: "PIROVANO 2297",
      puerta: "0",
      piso: "",
      depto: "",
      manzana: null,
      bloque: null,
      lote: null,
      casa: null,
      barrio: null,
      localidad: {
        idLocalidad: 2107,
        nombreLocalidad: "BAHIA BLANCA                            ",
        codigoPostal: 8000,
        codigoAFIPLocalidad: null,
        provincia: {
          idProvincia: 1,
          nombreProvincia: "BUENOS AIRES                  ",
          codigoAFIPProvincia: null,
        },
      },
      telefonos: null,
      celular: null,
      email: "",
      observaciones: null,
      tipoDocumento: null,
      categoriaIVA: {
        idCategoriaIVA: 0,
        descripcionCategoriaIVA: "RESPONSABLE INSCRIPTO         ",
        abreviaturaCategoriaIVA: "RI",
        codigoAFIPCategoriaIVA: "01",
      },
      condicionVenta: {
        descripcionCondicionVenta: "CONTADO",
        condicionVentaContado: true,
        idCondicionVenta: 0,
      },
      limiteCredito: 0,
      creditoSuspendido: false,
      numeroDocumento: "30-70891546-3",
      numeroListaPrecios: 0,
      identificador: "",
      enviaResumenPorMail: true,
      activo: true,
      cuentaInhabilitada: false,
      cuentaContable: null,
      segmento: null,
      subsegmento: null,
      emiteFacturayRemito: false,
      emiteRemito: false,
      exigeDatosVehiculo: false,
      exigeChofer: false,
      exigePatente: false,
      exigeVehiculo: false,
      exigeKm: false,
    },
  ],
};

const getClientes = async searchTerm => {
  // Filtrar solo clientes activos desde el inicio
  let filteredClientes = CLIENTES_HARDCODED_YPF.clientes.filter(cliente => cliente.activo);

  // Si hay un término de búsqueda, filtrar los resultados
  if (searchTerm && searchTerm.trim() !== "") {
    const normalizedSearchTerm = searchTerm.toLowerCase().trim();

    filteredClientes = filteredClientes.filter(cliente => {
      const razonSocial = (cliente.razonSocial || "").toLowerCase();
      const codigo = (cliente.codigo || "").toLowerCase().trim();
      const identificador = (cliente.identificador || "").toLowerCase();
      const numeroDocumento = (cliente.numeroDocumento || "").toLowerCase();

      return (
        razonSocial.includes(normalizedSearchTerm) ||
        codigo.includes(normalizedSearchTerm) ||
        identificador.includes(normalizedSearchTerm) ||
        numeroDocumento.includes(normalizedSearchTerm)
      );
    });
  }

  return {
    data: {
      ...CLIENTES_HARDCODED_YPF,
      clientes: filteredClientes,
      totalClientes: filteredClientes.length,
      totalPages: Math.ceil(filteredClientes.length / CLIENTES_HARDCODED_YPF.pageSize),
    },
  };
};

const clientes = {
  getClientes,
};

export default clientes;
